import { render } from "./ModelsTable.vue?vue&type=template&id=7aecb150&scoped=true&ts=true"
import script from "./ModelsTable.vue?vue&type=script&lang=ts"
export * from "./ModelsTable.vue?vue&type=script&lang=ts"

import "./ModelsTable.vue?vue&type=style&index=0&id=7aecb150&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aecb150"]])

export default __exports__